import { appSchema, tableSchema } from '@nozbe/watermelondb'

export default appSchema({
    version: 25,
    tables: [

        // ════════════════════════════════════════
        // DOMAIN 1: CORE
        // ════════════════════════════════════════

        tableSchema({
            name: 'merchants',
            columns: [
                { name: 'business_name', type: 'string' },
                { name: 'business_type', type: 'string', isOptional: true },
                { name: 'gstin', type: 'string', isOptional: true },
                { name: 'pan', type: 'string', isOptional: true },
                { name: 'phone', type: 'string', isIndexed: true },
                { name: 'email', type: 'string', isOptional: true },
                { name: 'address', type: 'string', isOptional: true },
                { name: 'city', type: 'string', isOptional: true },
                { name: 'state', type: 'string', isOptional: true },
                { name: 'pincode', type: 'string', isOptional: true },
                { name: 'logo_url', type: 'string', isOptional: true },
                { name: 'plan_tier', type: 'string' },
                { name: 'onboarding_status', type: 'string' },
                { name: 'approved_by_id', type: 'string', isOptional: true },
                { name: 'approved_at', type: 'number', isOptional: true },
                { name: 'rejection_reason', type: 'string', isOptional: true },
                { name: 'subscription_plan', type: 'string' },
                { name: 'max_stores', type: 'number' },
                { name: 'max_users', type: 'number' },
                { name: 'owner_phone', type: 'string', isOptional: true },
                { name: 'plan_status', type: 'string' },
                { name: 'plan_expires_at', type: 'number', isOptional: true },
                { name: 'max_devices', type: 'number' },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'stores',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'address', type: 'string', isOptional: true },
                { name: 'city', type: 'string', isOptional: true },
                { name: 'state', type: 'string', isOptional: true },
                { name: 'pincode', type: 'string', isOptional: true },
                { name: 'phone', type: 'string', isOptional: true },
                { name: 'currency', type: 'string' },
                { name: 'gstin_override', type: 'string', isOptional: true },
                { name: 'upi_id', type: 'string', isOptional: true },
                { name: 'invoice_prefix', type: 'string', isOptional: true },
                { name: 'next_invoice_no', type: 'number' },
                { name: 'status', type: 'string' },
                { name: 'require_day_open', type: 'boolean' },
                { name: 'emergency_bill_roles', type: 'string', isOptional: true },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'users',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'phone', type: 'string', isIndexed: true },
                { name: 'name', type: 'string', isOptional: true },
                { name: 'email', type: 'string', isOptional: true },
                { name: 'pin', type: 'string', isOptional: true },
                { name: 'avatar_url', type: 'string', isOptional: true },
                { name: 'role', type: 'string' },
                { name: 'onboarding_status', type: 'string' },
                { name: 'approved_by_id', type: 'string', isOptional: true },
                { name: 'approved_at', type: 'number', isOptional: true },
                { name: 'invited_by_id', type: 'string', isOptional: true },
                { name: 'last_login_at', type: 'number', isOptional: true },
                { name: 'is_primary_owner', type: 'boolean' },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'settings',
            columns: [
                { name: 'store_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'category', type: 'string' },
                { name: 'setting_key', type: 'string' },
                { name: 'setting_value', type: 'string' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'user_invitations',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'phone', type: 'string', isIndexed: true },
                { name: 'name', type: 'string', isOptional: true },
                { name: 'role', type: 'string' },
                { name: 'permissions', type: 'string', isOptional: true },
                { name: 'status', type: 'string', isIndexed: true },
                { name: 'invited_by_id', type: 'string' },
                { name: 'expires_at', type: 'number', isOptional: true },
                { name: 'requires_approval', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 2: PRODUCTS & INVENTORY
        // ════════════════════════════════════════

        tableSchema({
            name: 'categories',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'parent_id', type: 'string', isOptional: true },
                { name: 'sort_order', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'products',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'category_id', type: 'string', isOptional: true },
                { name: 'supplier_id', type: 'string', isOptional: true },
                { name: 'name', type: 'string' },
                { name: 'name_hindi', type: 'string', isOptional: true },
                { name: 'description', type: 'string', isOptional: true },
                { name: 'sku', type: 'string', isOptional: true, isIndexed: true },
                { name: 'barcode', type: 'string', isOptional: true, isIndexed: true },
                { name: 'hsn_code', type: 'string', isOptional: true, isIndexed: true },
                { name: 'mrp', type: 'number' },
                { name: 'selling_price', type: 'number' },
                { name: 'purchase_price', type: 'number' },
                { name: 'wholesale_price', type: 'number', isOptional: true },
                { name: 'tax_profile_id', type: 'string', isOptional: true },
                { name: 'gst_rate', type: 'number' },
                { name: 'cess_rate', type: 'number' },
                { name: 'unit', type: 'string' },
                { name: 'secondary_unit', type: 'string', isOptional: true },
                { name: 'conversion_rate', type: 'number', isOptional: true },
                { name: 'current_stock', type: 'number' },
                { name: 'low_stock_alert', type: 'number' },
                { name: 'track_inventory', type: 'boolean' },
                { name: 'is_service', type: 'boolean' },
                { name: 'image_url', type: 'string', isOptional: true },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
                // WDB-only: baseline for delta-rebase (not in Prisma)
                { name: 'last_sync_current_stock', type: 'number', isOptional: true },
            ]
        }),

        tableSchema({
            name: 'product_variants',
            columns: [
                { name: 'product_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'sku', type: 'string', isOptional: true },
                { name: 'barcode', type: 'string', isOptional: true },
                { name: 'price_adj', type: 'number' },
                { name: 'stock', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'batches',
            columns: [
                { name: 'product_id', type: 'string', isIndexed: true },
                { name: 'batch_number', type: 'string' },
                { name: 'mfg_date', type: 'number', isOptional: true },
                { name: 'expiry_date', type: 'number', isOptional: true, isIndexed: true },
                { name: 'quantity', type: 'number' },
                { name: 'last_sync_quantity', type: 'number', isOptional: true },
                { name: 'cost_price', type: 'number', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'godowns',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'address', type: 'string', isOptional: true },
                { name: 'is_default', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'stock_transfers',
            columns: [
                { name: 'transfer_number', type: 'string' },
                { name: 'from_godown_id', type: 'string', isIndexed: true },
                { name: 'to_godown_id', type: 'string', isIndexed: true },
                { name: 'status', type: 'string', isIndexed: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'dispatched_at', type: 'number', isOptional: true },
                { name: 'received_at', type: 'number', isOptional: true },
                { name: 'created_by_id', type: 'string' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'stock_transfer_items',
            columns: [
                { name: 'stock_transfer_id', type: 'string', isIndexed: true },
                { name: 'product_id', type: 'string' },
                { name: 'batch_id', type: 'string', isOptional: true },
                { name: 'quantity', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'stock_movements',
            columns: [
                { name: 'product_id', type: 'string', isIndexed: true },
                { name: 'godown_id', type: 'string', isOptional: true },
                { name: 'batch_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'quantity', type: 'number' },
                { name: 'reference_id', type: 'string', isOptional: true },
                { name: 'reference_type', type: 'string', isOptional: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'source', type: 'string', isOptional: true },
                { name: 'user_id', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number', isIndexed: true },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'suppliers',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'contact_person', type: 'string', isOptional: true },
                { name: 'phone', type: 'string', isOptional: true },
                { name: 'email', type: 'string', isOptional: true },
                { name: 'gstin', type: 'string', isOptional: true },
                { name: 'address', type: 'string', isOptional: true },
                { name: 'credit_limit', type: 'number' },
                { name: 'credit_days', type: 'number' },
                { name: 'current_balance', type: 'number' },
                { name: 'bank_details', type: 'string', isOptional: true },
                { name: 'tags', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
                // WDB-only: baselines for delta-rebase (not in Prisma)
                { name: 'last_sync_current_balance', type: 'number', isOptional: true },
            ]
        }),

        tableSchema({
            name: 'purchase_orders',
            columns: [
                { name: 'store_id', type: 'string' },
                { name: 'supplier_id', type: 'string' },
                { name: 'po_number', type: 'string' },
                { name: 'status', type: 'string' },
                { name: 'total_amount', type: 'number' },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'expected_date', type: 'number', isOptional: true },
                { name: 'supplier_invoice_no', type: 'string', isOptional: true },
                { name: 'supplier_invoice_date', type: 'number', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'po_line_items',
            columns: [
                { name: 'purchase_order_id', type: 'string', isIndexed: true },
                { name: 'product_id', type: 'string', isIndexed: true },
                { name: 'quantity', type: 'number' },
                { name: 'unit_price', type: 'number' },
                { name: 'received_qty', type: 'number' },
                { name: 'tax_rate', type: 'number' },
                { name: 'cgst_amount', type: 'number' },
                { name: 'sgst_amount', type: 'number' },
                { name: 'igst_amount', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'supplier_payments',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'supplier_id', type: 'string', isIndexed: true },
                { name: 'amount', type: 'number' },
                { name: 'method', type: 'string' },
                { name: 'transaction_ref', type: 'string', isOptional: true },
                { name: 'payment_date', type: 'number', isIndexed: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'supplier_ledger',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'supplier_id', type: 'string', isIndexed: true },
                { name: 'transaction_date', type: 'number', isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'amount', type: 'number' },
                { name: 'balance_after', type: 'number' },
                { name: 'reference_id', type: 'string', isOptional: true },
                { name: 'reference_type', type: 'string', isOptional: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'purchase_returns',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'supplier_id', type: 'string', isIndexed: true },
                { name: 'purchase_order_id', type: 'string', isOptional: true },
                { name: 'return_number', type: 'string' },
                { name: 'status', type: 'string' },
                { name: 'reason', type: 'string', isOptional: true },
                { name: 'total_amount', type: 'number' },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'purchase_return_items',
            columns: [
                { name: 'purchase_return_id', type: 'string', isIndexed: true },
                { name: 'product_id', type: 'string' },
                { name: 'batch_id', type: 'string', isOptional: true },
                { name: 'quantity', type: 'number' },
                { name: 'unit_price', type: 'number' },
                { name: 'reason', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 3: BILLING & INVOICING
        // ════════════════════════════════════════

        tableSchema({
            name: 'invoices',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'customer_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'created_by_id', type: 'string' },
                { name: 'invoice_number', type: 'string', isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'reference_invoice_id', type: 'string', isOptional: true },
                { name: 'status', type: 'string' },
                { name: 'payment_status', type: 'string', isIndexed: true },
                { name: 'subtotal', type: 'number' },
                { name: 'discount_type', type: 'string', isOptional: true },
                { name: 'discount_value', type: 'number' },
                { name: 'discount_amount', type: 'number' },
                { name: 'promotion_id', type: 'string', isOptional: true },
                { name: 'taxable_amount', type: 'number' },
                { name: 'cgst_amount', type: 'number' },
                { name: 'sgst_amount', type: 'number' },
                { name: 'igst_amount', type: 'number' },
                { name: 'cess_amount', type: 'number' },
                { name: 'total_tax', type: 'number' },
                { name: 'round_off', type: 'number' },
                { name: 'total_amount', type: 'number' },
                { name: 'paid_amount', type: 'number' },
                { name: 'due_amount', type: 'number' },
                { name: 'due_date', type: 'number', isOptional: true },
                { name: 'currency', type: 'string' },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'terms_conditions', type: 'string', isOptional: true },
                { name: 'is_inter_state', type: 'boolean' },
                { name: 'is_e_invoiced', type: 'boolean' },
                { name: 'irn', type: 'string', isOptional: true },
                { name: 'e_invoice_data', type: 'string', isOptional: true },
                { name: 'pdf_url', type: 'string', isOptional: true },
                { name: 'whatsapp_sent', type: 'boolean' },
                { name: 'device_id', type: 'string', isOptional: true },
                { name: 'billing_session_id', type: 'string', isOptional: true },
                { name: 'is_emergency', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number', isIndexed: true },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'line_items',
            columns: [
                { name: 'invoice_id', type: 'string', isIndexed: true },
                { name: 'product_id', type: 'string', isIndexed: true },
                { name: 'variant_id', type: 'string', isOptional: true },
                { name: 'batch_id', type: 'string', isOptional: true },
                { name: 'description', type: 'string', isOptional: true },
                { name: 'hsn_code', type: 'string', isOptional: true },
                { name: 'quantity', type: 'number' },
                { name: 'unit', type: 'string' },
                { name: 'unit_price', type: 'number' },
                { name: 'discount_type', type: 'string', isOptional: true },
                { name: 'discount_value', type: 'number' },
                { name: 'discount_amount', type: 'number' },
                { name: 'taxable_amount', type: 'number' },
                { name: 'gst_rate', type: 'number' },
                { name: 'cess_rate', type: 'number' },
                { name: 'cgst_amount', type: 'number' },
                { name: 'sgst_amount', type: 'number' },
                { name: 'igst_amount', type: 'number' },
                { name: 'cess_amount', type: 'number' },
                { name: 'total_amount', type: 'number' },
                // Unit cost snapshotted at sale time. Optional: rows written
                // before this column existed have no cost basis, and
                // profitability reports must report that rather than infer one.
                // Never recompute from products.purchase_price — it mutates on
                // every restock and would silently rewrite past margins.
                { name: 'cost_price', type: 'number', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'payments',
            columns: [
                { name: 'invoice_id', type: 'string', isIndexed: true },
                { name: 'method', type: 'string' },
                { name: 'amount', type: 'number' },
                { name: 'transaction_ref', type: 'string', isOptional: true },
                { name: 'status', type: 'string' },
                // Indexed: the Sales report selects payments on a cash basis
                // (by when money arrived), so this is the hot predicate.
                { name: 'received_at', type: 'number', isIndexed: true },
                { name: 'notes', type: 'string', isOptional: true },
                // The drawer this money crossed. Day close used to reach the
                // session through the payment's INVOICE, which cannot see a
                // khata payment collected today against last week's invoice.
                { name: 'billing_session_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 4: CUSTOMERS & LOYALTY
        // ════════════════════════════════════════

        tableSchema({
            name: 'customers',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string', isOptional: true },
                { name: 'phone', type: 'string', isOptional: true, isIndexed: true },
                { name: 'email', type: 'string', isOptional: true },
                { name: 'gstin', type: 'string', isOptional: true },
                { name: 'pan', type: 'string', isOptional: true },
                { name: 'address', type: 'string', isOptional: true },
                { name: 'city', type: 'string', isOptional: true },
                { name: 'state', type: 'string', isOptional: true },
                { name: 'pincode', type: 'string', isOptional: true },
                { name: 'group_id', type: 'string', isOptional: true },
                { name: 'credit_limit', type: 'number' },
                { name: 'balance', type: 'number' },
                { name: 'loyalty_tier_id', type: 'string', isOptional: true },
                { name: 'loyalty_points', type: 'number' },
                { name: 'total_spend', type: 'number' },
                { name: 'visit_count', type: 'number' },
                { name: 'last_visit_at', type: 'number', isOptional: true },
                { name: 'birthday', type: 'number', isOptional: true },
                { name: 'anniversary', type: 'number', isOptional: true },
                { name: 'tags', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
                // WDB-only: baselines for delta-rebase (not in Prisma)
                { name: 'last_sync_balance', type: 'number', isOptional: true },
                { name: 'last_sync_total_spend', type: 'number', isOptional: true },
                { name: 'last_sync_loyalty_points', type: 'number', isOptional: true },
                { name: 'last_sync_visit_count', type: 'number', isOptional: true },
            ]
        }),

        tableSchema({
            name: 'customer_groups',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'price_list_id', type: 'string', isOptional: true },
                { name: 'discount_percent', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'loyalty_tiers',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'min_spend', type: 'number' },
                { name: 'points_multiplier', type: 'number' },
                { name: 'discount_percent', type: 'number' },
                { name: 'sort_order', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'loyalty_transactions',
            columns: [
                { name: 'customer_id', type: 'string', isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'points', type: 'number' },
                { name: 'reference_id', type: 'string', isOptional: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number', isIndexed: true },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 5: PRICING & PROMOTIONS
        // ════════════════════════════════════════

        tableSchema({
            name: 'tax_profiles',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'tax_type', type: 'string' },
                { name: 'rate', type: 'number' },
                { name: 'cess_rate', type: 'number' },
                { name: 'is_inter_state', type: 'boolean' },
                { name: 'is_default', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'price_lists',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'price_list_items',
            columns: [
                { name: 'price_list_id', type: 'string', isIndexed: true },
                { name: 'product_id', type: 'string' },
                { name: 'price', type: 'number' },
                { name: 'min_quantity', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'promotions',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'code', type: 'string', isOptional: true, isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'value', type: 'number' },
                { name: 'min_order_value', type: 'number', isOptional: true },
                { name: 'max_discount', type: 'number', isOptional: true },
                { name: 'applicable_to', type: 'string' },
                { name: 'applicable_ids', type: 'string', isOptional: true },
                { name: 'start_date', type: 'number' },
                { name: 'end_date', type: 'number' },
                { name: 'usage_limit', type: 'number', isOptional: true },
                { name: 'used_count', type: 'number' },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
                // WDB-only: baseline for delta-rebase (not in Prisma)
                { name: 'last_sync_used_count', type: 'number', isOptional: true },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 6: GST & COMPLIANCE
        // ════════════════════════════════════════

        tableSchema({
            name: 'gst_rate_slabs',
            columns: [
                { name: 'rate', type: 'number' },
                { name: 'label', type: 'string' },
                { name: 'is_active', type: 'boolean' },
                { name: 'effective_from', type: 'number' },
                { name: 'sort_order', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'indian_states',
            columns: [
                { name: 'code', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'short_name', type: 'string' },
                { name: 'is_ut', type: 'boolean' },
                { name: 'is_active', type: 'boolean' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'hsn_master',
            columns: [
                { name: 'code', type: 'string', isIndexed: true },
                { name: 'description', type: 'string' },
                { name: 'gst_rate', type: 'number' },
                { name: 'cess_rate', type: 'number' },
                { name: 'keywords', type: 'string', isOptional: true },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'gst_filings',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'return_type', type: 'string' },
                { name: 'period', type: 'string' },
                { name: 'status', type: 'string' },
                { name: 'total_taxable', type: 'number', isOptional: true },
                { name: 'total_tax', type: 'number', isOptional: true },
                { name: 'filing_data', type: 'string', isOptional: true },
                { name: 'filed_at', type: 'number', isOptional: true },
                { name: 'ack_number', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'e_invoices',
            columns: [
                { name: 'invoice_id', type: 'string', isIndexed: true },
                { name: 'irn', type: 'string', isOptional: true },
                { name: 'ack_number', type: 'string', isOptional: true },
                { name: 'ack_date', type: 'number', isOptional: true },
                { name: 'signed_qr', type: 'string', isOptional: true },
                { name: 'signed_invoice', type: 'string', isOptional: true },
                { name: 'status', type: 'string' },
                { name: 'error_message', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'e_way_bills',
            columns: [
                { name: 'invoice_id', type: 'string', isIndexed: true },
                { name: 'ewb_number', type: 'string', isOptional: true },
                { name: 'from_state', type: 'string' },
                { name: 'to_state', type: 'string' },
                { name: 'trans_mode', type: 'string', isOptional: true },
                { name: 'vehicle_number', type: 'string', isOptional: true },
                { name: 'valid_upto', type: 'number', isOptional: true },
                { name: 'status', type: 'string' },
                { name: 'error_message', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 7: STAFF MANAGEMENT
        // ════════════════════════════════════════

        tableSchema({
            name: 'staff_assignments',
            columns: [
                { name: 'user_id', type: 'string', isIndexed: true },
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'permissions', type: 'string', isOptional: true },
                { name: 'commission_rate', type: 'number' },
                { name: 'salary', type: 'number' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'shifts',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'start_time', type: 'string' },
                { name: 'end_time', type: 'string' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'attendance',
            columns: [
                { name: 'user_id', type: 'string', isIndexed: true },
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'shift_id', type: 'string', isOptional: true },
                { name: 'date', type: 'number' },
                { name: 'check_in', type: 'number', isOptional: true },
                { name: 'check_out', type: 'number', isOptional: true },
                { name: 'status', type: 'string' },
                { name: 'hours_worked', type: 'number', isOptional: true },
                { name: 'notes', type: 'string', isOptional: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'commissions',
            columns: [
                { name: 'user_id', type: 'string', isIndexed: true },
                { name: 'invoice_id', type: 'string' },
                { name: 'amount', type: 'number' },
                { name: 'rate', type: 'number' },
                { name: 'status', type: 'string' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 8: FINANCE & EXPENSES
        // ════════════════════════════════════════

        tableSchema({
            name: 'expense_categories',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'name', type: 'string' },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'expenses',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'category_id', type: 'string' },
                { name: 'amount', type: 'number' },
                { name: 'payment_method', type: 'string', isOptional: true },
                { name: 'description', type: 'string', isOptional: true },
                { name: 'expense_date', type: 'number', isIndexed: true },
                { name: 'receipt_url', type: 'string', isOptional: true },
                // The drawer this cash left. Day close used to subtract the
                // whole store's expenses for the day from every open session.
                { name: 'billing_session_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 9: DEVICES & SYNC
        // ════════════════════════════════════════

        tableSchema({
            name: 'devices',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'user_id', type: 'string', isOptional: true },
                { name: 'device_name', type: 'string', isOptional: true },
                { name: 'platform', type: 'string', isOptional: true },
                { name: 'app_version', type: 'string', isOptional: true },
                { name: 'push_token', type: 'string', isOptional: true },
                { name: 'last_sync_at', type: 'number', isOptional: true },
                { name: 'store_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'device_slot', type: 'number', isOptional: true },
                { name: 'is_active', type: 'boolean' },
                { name: 'is_wiped', type: 'boolean' },
                { name: 'pin_hash', type: 'string', isOptional: true },
                { name: 'device_type', type: 'string' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // ════════════════════════════════════════
        // DOMAIN 2b: SUPPLIER IMPORT MAPPINGS
        // ════════════════════════════════════════

        tableSchema({
            name: 'supplier_import_mappings',
            columns: [
                { name: 'merchant_id',     type: 'string', isIndexed: true },
                { name: 'supplier_id',     type: 'string', isIndexed: true },
                { name: 'mapping_name',    type: 'string' },
                { name: 'column_mappings', type: 'string' },  // JSON string
                { name: 'file_type',       type: 'string' },
                { name: 'header_row',      type: 'number' },
                { name: 'skip_rows',       type: 'number' },
                { name: 'notes',           type: 'string', isOptional: true },
                { name: 'is_default',      type: 'boolean' },
                { name: 'version',         type: 'number' },
                { name: 'is_synced',       type: 'boolean' },
                { name: 'is_deleted',      type: 'boolean' },
                { name: 'created_at',      type: 'number' },
                { name: 'updated_at',      type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 10: SYSTEM
        // ════════════════════════════════════════

        tableSchema({
            name: 'audit_logs',
            columns: [
                { name: 'merchant_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'user_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'admin_user_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'entity_type', type: 'string', isIndexed: true },
                { name: 'entity_id', type: 'string' },
                { name: 'action', type: 'string' },
                { name: 'changes', type: 'string', isOptional: true },
                { name: 'ip_address', type: 'string', isOptional: true },
                { name: 'created_at', type: 'number', isIndexed: true },
            ]
        }),

        tableSchema({
            name: 'sync_logs',
            columns: [
                { name: 'merchant_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'device_id', type: 'string', isIndexed: true },
                { name: 'push_id', type: 'string', isOptional: true },
                { name: 'direction', type: 'string' },
                { name: 'table_name', type: 'string' },
                { name: 'record_count', type: 'number' },
                { name: 'status', type: 'string' },
                { name: 'error_message', type: 'string', isOptional: true },
                { name: 'duration_ms', type: 'number', isOptional: true },
                { name: 'created_at', type: 'number', isIndexed: true },
            ]
        }),

        tableSchema({
            name: 'notifications',
            columns: [
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'store_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'user_id', type: 'string', isOptional: true, isIndexed: true },
                { name: 'type', type: 'string' },
                { name: 'title', type: 'string' },
                { name: 'body', type: 'string' },
                { name: 'data', type: 'string', isOptional: true },
                { name: 'is_read', type: 'boolean', isIndexed: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════
        // DOMAIN 10b: AI / CACHE
        // ════════════════════════════════════════

        tableSchema({
            name: 'hsn_cache',
            columns: [
                { name: 'product_query', type: 'string', isIndexed: true },
                { name: 'hsn_code', type: 'string' },
                { name: 'description', type: 'string' },
                { name: 'gst_rate', type: 'number' },
                { name: 'confidence', type: 'string' },
                { name: 'alternatives_json', type: 'string' },
                { name: 'note', type: 'string', isOptional: true },
                { name: 'source', type: 'string' },
                { name: 'hit_count', type: 'number' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        tableSchema({
            name: 'reorder_suggestions',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'merchant_id', type: 'string', isIndexed: true },
                { name: 'generated_at', type: 'number' },
                { name: 'urgent_json', type: 'string' },
                { name: 'plan_json', type: 'string' },
                { name: 'reduce_json', type: 'string' },
                { name: 'seasonal_tip', type: 'string', isOptional: true },
                { name: 'is_read', type: 'boolean' },
                { name: 'updated_at', type: 'number' },
            ]
        }),

        // ════════════════════════════════════════════
        // DOMAIN 7b: BILLING SESSIONS
        // ════════════════════════════════════════════

        tableSchema({
            name: 'billing_sessions',
            columns: [
                { name: 'store_id', type: 'string', isIndexed: true },
                { name: 'device_id', type: 'string', isIndexed: true },
                { name: 'user_id', type: 'string' },
                { name: 'session_date', type: 'number', isIndexed: true },
                { name: 'opened_at', type: 'number' },
                { name: 'closed_at', type: 'number', isOptional: true },
                { name: 'closed_by_id', type: 'string', isOptional: true },
                { name: 'opening_cash', type: 'number' },
                { name: 'closing_cash', type: 'number', isOptional: true },
                { name: 'expected_cash', type: 'number', isOptional: true },
                { name: 'variance', type: 'number', isOptional: true },
                { name: 'status', type: 'string', isIndexed: true },
                { name: 'version', type: 'number' },
                { name: 'is_synced', type: 'boolean' },
                { name: 'is_deleted', type: 'boolean' },
                { name: 'created_at', type: 'number' },
                { name: 'updated_at', type: 'number' },
            ]
        }),
    ]
})
